/**
* Created by bieao on 2020/4/1.
*/
<template>
  <div class="container">
    <div class="top">
      <div class="header">
        <img data-v-087656f9="" src="/static/img/logo.svg" alt="logo" class="logo">
        <span data-v-087656f9="" class="title">萨达推送平台</span>
      </div>
      <div class="desc">
        专业的数据推送平台
      </div>
    </div>
    <div class="main">
      <el-form key='1' :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item prop="username">
          <el-input type="text" prefix-icon="el-icon-user" v-model.trim="ruleForm.username" auto-complete="off" placeholder="用户名" @keyup.13.native='handleSubmit'></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" prefix-icon="el-icon-lock" v-model.trim="ruleForm.password" auto-complete="off" placeholder="密码" @keyup.13.native='handleSubmit'></el-input>
        </el-form-item>
        <el-form-item style="width:100%;">
          <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit" >登录</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <div class="copyright">
        Copyright © 2021 北京萨达智能技术有限公司
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LoginPage',
  data () {
    return {
      ruleForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    handleSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const {username, password} = this.ruleForm
          if (username === 'sada' && password === 'sada1234') {
            localStorage.setItem('loginParams', JSON.stringify(this.ruleForm))
            this.$router.push('/PushDest')
          } else {
            this.$notify({
              title: '无效用户名和密码',
              message: '请联系管理员！',
              type: 'warning'
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .container{
    width: 100%;
    height: 100%;
    background-size: 100%;
    background: #f0f2f5 url('/static/img/login-bg.svg') no-repeat 100% 100%;
    padding: 110px 0 144px;
    position: relative;
    .top{
      text-align: center;
      margin-bottom:40px;
      .header{
        height: 44px;
        line-height: 44px;
        .logo{
          height: 44px;
          vertical-align: top;
          margin-right: 16px;
          border-style: none;
        }
        .title{
          font-size: 33px;
          color: rgba(0,0,0,.85);
          font-family: Avenir,Helvetica Neue,Arial,Helvetica,sans-serif;
          font-weight: 600;
          position: relative;
          top: 2px;
        }
      }
      .desc{
        font-size: 14px;
        color: rgba(0,0,0,.45);
        margin-top: 12px;
      }
    }
    .main{
      min-width: 260px;
      width: 368px;
      margin: 0 auto;
      .remember{
        margin-bottom:20px;
      }
    }
    .footer{
      position: absolute;
      width: 100%;
      bottom: 0;
      padding: 0 16px;
      margin: 48px 0 24px;
      text-align: center;
      .copyright{
        color: rgba(0,0,0,.45);
        font-size: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login.vue